var map = {
	"./gallery1.jpg": "d918",
	"./gallery10.jpg": "ef55",
	"./gallery11.jpg": "f8a8",
	"./gallery12.jpg": "d100",
	"./gallery13.jpg": "de91",
	"./gallery14.jpg": "7f6a",
	"./gallery15.jpg": "3236",
	"./gallery2.jpg": "c49e",
	"./gallery3.jpg": "e588",
	"./gallery4.jpg": "76a8",
	"./gallery5.jpg": "9cb8",
	"./gallery6.jpg": "041a",
	"./gallery7.jpg": "4997",
	"./gallery8.jpg": "731d",
	"./gallery9.jpg": "ab61"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ba48";